<template>
  <div class="setup-plan-beward">
    <div class="setup-plan-beward__actions setup-plan-beward__actions--top">
      <div class="setup-plan-beward__actions-left">
        <v-btn color="primary" class="text-none" rounded @click="savePlan()">
          <v-icon left>mdi-content-save-outline</v-icon>
          Сохранить
        </v-btn>
        <v-btn color="primary" outlined rounded class="text-none ml-2" @click.prevent="returnDoorphone()">
          <v-icon left>mdi-close</v-icon>
          Отменить
        </v-btn>
      </div>
      <v-spacer />
      <div v-if="roleName !== 'master'" class="setup-plan-beward__actions-right">
        <v-btn
          color="primary"
          outlined
          class="text-none"
          rounded
          @click.prevent="dialogChange = true"
        >
          <v-icon left>mdi-cog-outline</v-icon>
          Изменить параметр Кв
        </v-btn>
      </div>
      <v-dialog v-model="dialogChange" persistent :retain-focus="false" max-width="520" content-class="dialog-border-radius">
        <v-card :loading="loading">
          <v-card-title class="headline">Обновить пресет соответствия квартир?</v-card-title>
          <v-card-text>Подтверждая, вы измените параметры квартир.</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" outlined class="text-none rounded" @click.prevent="dialogChange = false">Отменить</v-btn>
            <v-btn color="primary" class="text-none rounded" dark :loading="loading" @click="changeApartment()">
              <v-icon left small>mdi-check</v-icon>
              Изменить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="setup-plan-beward__actions-right setup-plan-beward__actions-right--group" v-if="changeableDiapazon">
        <v-btn
          v-if="$checkPermission('import_rules')"
          @click.stop="dialog = true"
          color="primary"
          outlined
          class="text-none rounded"
        >
          <v-icon left>mdi-import</v-icon>
          Импортировать
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="570" content-class="dialog-border-radius">
          <v-card>
            <v-card-title class="headline">Импортируя, вы сотрёте существующий план набора в базе данных, а так же пропадут sip данные зарегистрированных пользователей.</v-card-title>
            <v-card-text>Подтверждая, вы импортируете план набора.</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" outlined class="text-none rounded" @click.prevent="importRulesDialog()">Отменить</v-btn>
              <v-btn color="primary" class="text-none rounded" dark @click.prevent="importRulesData()">
                <v-icon left small>mdi-import</v-icon>
                Импортировать
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" class="text-none rounded ml-2" dark @click="addPlan">
          <v-icon left>mdi-plus</v-icon>
          Добавить
        </v-btn>
      </div>
    </div>
    <v-data-table
      ref="planTable"
      class="table"
      :headers="headersPlanBeward"
      :items="modifiedPlan"
      :disable-sort="true"
      :footer-props="{
          showFirstLastPage: true,
        }"
    >
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              text
              x-large
              right
              class="btn__icon mr-4"
              width="18"
              @click.stop="$set(warningDialog, item.Number, true)"
              :disabled="roleName !== 'admin'"
            >
              <v-icon>mdi-home-lock-open</v-icon>
            </v-btn>
          </template>
          <span>Код открытия</span>
        </v-tooltip>

        <v-dialog v-model="warningDialog[item.Number]" max-width="400px" content-class="dialog-border-radius">
          <v-card>
            <v-card-title class="headline">Предупреждение</v-card-title>
            <v-card-text class="text-body-2">
              При получении кода, он будет действителен в течение часа, после он автоматически обновится.
              Если домофон не в сети, код попадет в отложенную задачу и будет выполнен позже.
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" text @click="openDialog(item)">Посмотреть код</v-btn>
              <v-btn text @click="$set(warningDialog, item.Number, false)">Отмена</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCode[item.Number]" max-width="650px" content-class="dialog-border-radius">
          <v-card>
            <v-progress-linear
              v-if="loadingCode"
              indeterminate
              color="primary"
              height="3"
              class="mt-2"
            ></v-progress-linear>
            <v-card-title class="headline">
              <v-icon left color="primary">mdi-key</v-icon>
              Код открытия двери
            </v-card-title>
            <p class="text-body-2 pa-2 ml-4">
              Этот код клиент может получить в приложении, нажав на кнопку <strong>"Гостевой доступ"</strong>.
            </p>

            <p class="text-body-2 pa-2 ml-4">
              При получении кода клиентом, код будет действителен в течение часа.
              Если в момент получения кода домофон не будет в сети, запрос на обновление кода попадет в отложенную задачу
              и будет выполнен позже, когда домофон будет в сети.
            </p>

            <p class="text-body-2 pa-2 ml-4">
              Если у домофона есть связанные устройства (калитки или дополнительные входы), код также будет обновлен и для них.
              Кроме того, предоставленный клиенту код будет работать и на всех связанных устройствах.
            </p>

            <v-card-text>
              <h4 v-if="!loadingCode">Индивидуальный код открытия двери - <span style="color: black">{{ doorCode }}</span></h4>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn text color="grey" @click="closeDialog(item.Number)">Закрыть</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-icon
          :disabled="disableDelete"
          @click="deleteItem(item.Number)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:item.Number="{ item }">
        <v-text-field
          v-model='item.Number'
          class='mt-4'
          solo
          type="number"
          outlined
          dense
          flat
          :disabled="disableApartment"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Phone1="{ item }">
        <v-text-field
          v-model='item.Phone1'
          class='mt-4'
          solo
          type="text"
          outlined
          dense
          flat
          :disabled="disableRules"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Phone2="{ item }">
        <v-text-field
          v-model='item.Phone2'
          class='mt-4'
          solo
          outlined
          type="text"
          dense
          flat
          :disabled="disableRules"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Phone3="{ item }">
        <v-text-field
          v-model='item.Phone3'
          class='mt-4'
          solo
          type="text"
          outlined
          dense
          flat
          :disabled="disableRules"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Phone4="{ item }">
        <v-text-field
          v-model='item.Phone4'
          class='mt-4'
          solo
          outlined
          type="text"
          dense
          flat
          :disabled="disableRules"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Phone5="{ item }">
        <v-text-field
          v-model='item.Phone5'
          class='mt-4'
          solo
          type="text"
          outlined
          dense
          flat
          :disabled="disableRules"
        >
        </v-text-field>
      </template>
      <template v-slot:item.Comment="{ item }">
        <v-text-field
          v-model='item.Comment'
          class='mt-4'
          solo
          type="text"
          outlined
          dense
          flat
          :disabled="disableComment"
        >
        </v-text-field>
      </template>
      <template v-slot:item.PhonesActive="{ item }">
        <v-checkbox
          class='mt-4'
          type="checkbox"
          label="Включено"
          v-bind:true-value="valueTrue"
          v-bind:false-value="valueFalse"
          v-model='item.PhonesActive'
          :disabled="disableActivity"
        >
        </v-checkbox>
      </template>
    </v-data-table>
    <div class="setup-plan-beward__actions setup-plan-beward__actions--bottom mt-3">
      <v-btn color="primary" class="text-none" rounded @click="savePlan()">
        <v-icon left>mdi-content-save-outline</v-icon>
        Сохранить
      </v-btn>
      <v-btn color="primary" outlined rounded class="text-none ml-2" @click.prevent="returnDoorphone()">
        <v-icon left>mdi-close</v-icon>
        Отменить
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { headersPlanBeward } from '../../../consts';

export default {
  name: 'SetupPlanBeward',
  data: () => {
    return {
      modifiedPlan: [],
      dialog: false,
      dialogChange: false,
      loading: false,
      disableApartment: true,
      disableRules: true,
      disableLogin: true,
      disableComment: true,
      disableActivity: true,
      disableDelete: true,
      changeableDiapazon: false,
      headersPlanBeward,
      warningDialog: {},
      loadingCode: false,
      dialogCode: {},
      doorCode: '',
      newDoorCode: '',
    };
  },
  computed: {
    ...mapGetters({
      recruitmentPlan: 'Doorphone/rules',
      doorphone: 'Doorphone/doorphone',
      roleName: 'roleName',
      rules: 'Doorphone/rules',
    }),
    valueTrue () {
      return 'on';
    },
    valueFalse () {
      return 'off';
    },
  },
  created () {
    this.getRules(this.$route.params.id)
      .then(() => {
        if (this.recruitmentPlan !== undefined) {
          this.modifiedPlan = JSON.parse(JSON.stringify(this.recruitmentPlan));
        }
      });
    switch (this.roleName) {
      case 'admin': case 'agent':
        this.changeableDiapazon = true;
        this.disableApartment = false;
        this.disableComment = false;
        this.disableActivity = false;
        this.disableLogin = false;
        this.disableRules = false;
        this.disableDelete = false;
        break;
      case 'admin-engineer':
        this.disableApartment = false;
        this.disableComment = false;
        this.disableActivity = false;
        this.changeableDiapazon = true;
        this.disableLogin = false;
        this.disableRules = false;
        break;
      case 'manager':
        this.disableComment = false;
        this.disableLogin = false;
        this.disableActivity = false;
        break;
      case 'master' :
        this.disableApartment = false;
        this.disableRules = false;
        this.disableComment = false;
        this.disableLogin = false;
        this.changeableDiapazon = true;
        this.disableDelete = true;
        this.disableActivity = true;
    }
  },
  methods: {
    ...mapActions({
      changeApartments: 'Doorphone/changeApartments',
      updateApartmentsBeward: 'Doorphone/updateApartmentsBeward',
      getRules: 'Doorphone/getRules',
      importRules: 'Doorphone/importRules',
      getCodeApartment: 'Doorphone/getCodeApartment',
      setCodeApartment: 'Doorphone/setCodeApartment',
    }),
    openDialog (item) {
      this.$set(this.dialogCode, item.Number, true);
      this.$set(this.warningDialog, item.Number, false);
      this.getCode(item);
    },
    closeDialog (Number) {
      this.$set(this.dialogCode, Number, false);
      this.$set(this.warningDialog, Number, false);
      this.doorCode = null;
    },
    getCode (item) {
      this.loadingCode = true;
      this.getCodeApartment({
        id: this.$route.params.id,
        number: item.Number,
      })
        .then(data => {
          this.doorCode = data.code;
        })
        .catch(() => {
          this.$flash_warning('Ошибка получения кода.');
        })
        .finally(() => {
          this.loadingCode = false;
        });
    },
    setCode (item) {
      this.loadingCode = true;
      this.setCodeApartment({
        id: this.$route.params.id,
        number: item.Prefix,
      })
        .then(data => {
          this.newDoorCode = data.newCode;
          this.doorCode = this.newDoorCode;
          this.$flash_success('Индивидуальный код успешно сгенерирован и добавлен клиенту.');
        })
        .catch(() => {
          this.$flash_warning('Ошибка изменения кода. Возможно устройство не в сети.');
        })
        .finally(() => {
          this.loadingCode = false;
        });
    },
    changeApartment () {
      this.loading = true;
      this.changeApartments({
        id: this.$route.params.id,
      })
        .then(() => {
          this.dialogChange = false;
          this.loading = false;
          this.$flash_success('Изменение параметров выполнено успешно');
        })
        .catch(() => {
          this.loading = false;
          this.dialogChange = false;
          this.$flash_warning('Не удалось измененить параметры Кв');
        });
    },
    returnDoorphone () {
      this.$router.push({ name: 'DetailDoorphone', params: { id: this.$route.params.id } });
    },
    deleteItem (id) {
      this.modifiedPlan = this.modifiedPlan
        .filter(plan => plan.Number !== id)
        .map((plan, index) => ({ ...plan, Number: index + 1 }));
    },
    addPlan () {
      this.modifiedPlan = [...this.modifiedPlan,
        {
          Number: this.modifiedPlan.length + 1,
          Phone1: '',
          Phone2: '',
          Phone3: '',
          Phone4: '',
          Phone5: '',
          PhonesActive: 'on',
          BlockCMS: 'off',
          Comment: '',
        },
      ];
      this.$refs.planTable.$el.children[0].scrollTop = this.$refs.planTable.$el.children[0].children[0].clientHeight;
      this.$flash_success('Ячейка добавлена в конец списка');
    },
    importRulesData () {
      this.importRules(this.$route.params.id)
        .then(importRules => {
          this.$flash_success('Импортирование успешно завершено');
          this.dialog = false;
          this.getRules(this.$route.params.id)
            .then(() => {
              this.modifiedPlan = JSON.parse(JSON.stringify(this.recruitmentPlan));
            });
        })
        .catch(() => {
          this.$flash_warning('Ошибка импортирования');
        });
    },
    importRulesDialog () {
      this.dialog = false;
    },
    savePlan () {
      const dataRules = [];
      for (let i = 0; i < this.modifiedPlan.length; i++) {
        dataRules.push({
          Number: String(this.modifiedPlan[i].Number),
          Phone1: this.modifiedPlan[i].Phone1,
          Phone2: this.modifiedPlan[i].Phone2,
          Phone3: this.modifiedPlan[i].Phone3,
          Phone4: this.modifiedPlan[i].Phone4,
          Phone5: this.modifiedPlan[i].Phone5,
          BlockCMS: this.modifiedPlan[i].BlockCMS,
          PhonesActive: this.modifiedPlan[i].PhonesActive,
          Comment: this.modifiedPlan[i].Comment,
        });
      }
      this.updateApartmentsBeward({ id: this.$route.params.id, rules: dataRules })
        .then(() => {
          this.$flash_success('Изменения успешно сохранены');
        })
        .catch((message) => {
          if (message.length > 0) {
            for (let i = 0; i < message.length; i++) {
              this.$flash_warning(message[i]);
            }
          } else {
            this.$flash_warning('Ошибка при смене плана набора');
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.setup-plan-beward__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.setup-plan-beward__actions--top {
  margin-bottom: 16px;
}
.setup-plan-beward__actions-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.setup-plan-beward__actions-right {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.setup-plan-beward__actions-right--group {
  margin-left: auto;
}
::v-deep .dialog-border-radius {
  border-radius: 12px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 10px !important;
  font-size: 13px !important;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
